export default __webpack_public_path__ + "static/media/wel3.a1cdc498.png";